module.exports = __webpack_public_path__ + "img/mobile.97390abe.svg";